<template>
  <div class="study-test-template" theme>
    <div id="study-test-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'study',
      parts: [
        {
          elem: '#study-test-content',
          htmlFile: 'study-test'
        }
      ]
    }
  }
}
</script>
